import React, { } from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './redux/reducers'
import App from './App.js'
import './index.css'
import * as serviceWorker from './serviceWorker'

const composeEnhancers = process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware // lets us dispatch() functions
    )
  )
)

const Root = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

if (document.getElementById('app')) {
  render(<Root />, document.getElementById('app'))
}

if (process.env.NODE_ENV === 'production') {
  serviceWorker.register()
} else {
  serviceWorker.unregister()
}
